export function buildPhone( // E.164
  country: string,
  area: string,
  prefix: string,
  line: string,
): string {
  const NUM = country + area + prefix + line;
  return `+${NUM}`;
}
